import { useTranslation } from "react-i18next";
import { ReactComponent as StrmCycleArrow } from "shared/assets/images/icon-strm-cycle-arrow.svg";
import CycleFooterNote from "./components/CycleFooterNote";
import CycleStageCard from "./components/CycleStageCard";
import "./Cycles.scss";

const Cycles: React.FC = () => {
  const { t } = useTranslation();

  const cards = [
    {
      description: t("pages.Cycles.preReleaseDescription"),
      height: 284,
      tag: t("pages.Cycles.preReleaseTag"),
      title: t("pages.Cycles.preReleaseTitle"),
      variant: "pre-release" as const,
    },
    {
      description: t("pages.Cycles.launchDescription"),
      height: 321,
      tag: t("pages.Cycles.launchTag"),
      title: t("pages.Cycles.launchTitle"),
      variant: "launch" as const,
    },
    {
      description: t("pages.Cycles.postReleaseDescription"),
      height: 370,
      tag: t("pages.Cycles.postReleaseTag"),
      title: t("pages.Cycles.postReleaseTitle"),
      variant: "post-release" as const,
    },
  ];

  return (
    <section className="cycles-page">
      <span className="cycles-page__glow cycles-page__glow--left" aria-hidden="true" />
      <span
        className="cycles-page__glow cycles-page__glow--right"
        aria-hidden="true"
      />

      <div className="cycles-page__content">
        <div className="cycles-page__hero">
          <p className="cycles-page__eyebrow">{t("pages.Cycles.eyebrow")}</p>
          <h1 className="cycles-page__title heading-h3">{t("pages.Cycles.title")}</h1>
          <p className="cycles-page__subtitle">{t("pages.Cycles.subtitle")}</p>
        </div>

        <div className="cycles-page__track scroll-style" role="list">
          {cards.map((card) => (
            <div
              className="cycles-page__track-item"
              role="listitem"
              key={card.variant}
            >
              <CycleStageCard {...card} />
            </div>
          ))}
        </div>

        <div className="cycles-page__cta-wrapper">
          <button type="button" className="cycles-page__cta">
            <span>{t("pages.Cycles.ctaLabel")}</span>
            <StrmCycleArrow className="cycles-page__cta-icon" aria-hidden="true" />
          </button>
        </div>

        <div className="cycles-page__footer-wrapper">
          <CycleFooterNote text={t("pages.Cycles.footerNote")} />
        </div>
      </div>
    </section>
  );
};

export default Cycles;
